import InfoPage from "../components/InfoPage";

export default function PrivacyPolicy() {
    return (
        <InfoPage title="Privacy Policy" subtitle="How we collect, use, and protect your information" testid="privacy-page">
            <H2>Data we collect</H2>
            <ul className="mt-2 space-y-1.5 list-disc list-inside">
                <li>Name, phone number</li>
                <li>Email (optional)</li>
                <li>Payment information (processed via Razorpay)</li>
                <li>Booking history</li>
            </ul>

            <H2>How we use it</H2>
            <ul className="mt-2 space-y-1.5 list-disc list-inside">
                <li>To confirm bookings and send invoices</li>
                <li>WhatsApp updates (with your consent)</li>
                <li>Community features — finding teammates, joining open games</li>
                <li>Improving our services and customer support</li>
            </ul>

            <H2>Who we share data with</H2>
            <p className="mt-2">
                We share data only with the minimum third parties needed to run the platform: <b className="text-white">Razorpay</b> (payment processing) and our <b className="text-white">WhatsApp API provider</b> (AiSensy, for transactional messaging). We never sell your data.
            </p>

            <H2>Your rights</H2>
            <p className="mt-2">
                You may request access to, correction of, or deletion of your personal data by emailing us at <a className="text-[#00FF66] font-semibold" href="mailto:driveorkick@gmail.com">driveorkick@gmail.com</a>.
            </p>
        </InfoPage>
    );
}

function H2({ children }) {
    return <h2 className="font-display text-lg font-bold uppercase text-white mt-6 mb-1 tracking-widest">{children}</h2>;
}
